interface MetaTag {
  name: string
  content: string
}

interface LinkTag {
  rel: string
  href: string
  as?: string
  crossOrigin?: string
  fetchPriority?: 'high' | 'low' | 'auto'
}

/**
 * MOCKUP OFICIAL del producto (los 6 tomos). Es el elemento LCP del hero y se
 * reutiliza en la sección de oferta. No aplicar filtros, recortes ni textos
 * encima: se muestra siempre completo y con su proporción original.
 */
export const HERO_IMAGE_URL =
  'https://cdn.magicpatterns.com/uploads/budAbgPvaYhG4cn1hzmz4K/mock_up_final.png'

/** Mujer sirviendo un plato keto en una cocina luminosa (cierre). */
export const AUDIENCE_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/2f4ce41b-5608-4393-ad37-cf36fec25a79.jpg'

/** Mesa con platos keto + sin TACC (sección de atributos de las recetas). */
export const RECIPES_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/bc53929e-6ab9-4f93-bae1-637accd5b7b4.jpg'

/** Vista interior: página estilo revista gastronómica. */
export const INTERIOR_PAGE_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/d001ff27-ab3d-47af-b5bb-3277596ad540.jpg'

/** Vista interior: preparación paso a paso. */
export const INTERIOR_STEPS_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/698dd59e-9d2d-4300-a063-feafe3eeb563.jpg'

/** Vista interior: la colección abierta en celular y tablet. */
export const INTERIOR_DEVICE_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/7a0b147f-6d69-4f2b-a4f0-c6d2651970ee.jpg'

/** La sección de oferta muestra el mockup oficial del producto. */
export const BUNDLE_IMAGE_URL = HERO_IMAGE_URL

const PAGE_TITLE =
  '500+ Recetas Keto + Sin TACC — 6 tomos digitales con ingredientes de Argentina'

const META_TAGS: MetaTag[] = [
  {
    name: 'description',
    content:
      '500+ Recetas Keto + Sin TACC: una colección de 6 tomos digitales con más de 500 recetas para desayunos, meriendas, almuerzos, cenas, snacks y más. Fáciles, rápidas y con ingredientes que conseguís en Argentina. Incluye 4 bonos de regalo.',
  },
]

const LINK_TAGS: LinkTag[] = [
  // Warm up the font + image origins before the CSS/image requests are made.
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
  { rel: 'preconnect', href: 'https://cdn.magicpatterns.com' },
  // Discover the LCP image as early as possible, at high priority.
  { rel: 'preload', href: HERO_IMAGE_URL, as: 'image', fetchPriority: 'high' },
]

/**
 * Inserts global <meta> and resource-hint <link> tags into <head> once.
 * Existing tags are never duplicated.
 */
export function initHeadMeta(): void {
  if (typeof document === 'undefined') return

  document.title = PAGE_TITLE

  META_TAGS.forEach(({ name, content }) => {
    if (document.querySelector(`meta[name="${name}"]`)) return

    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.head.appendChild(meta)
  })

  LINK_TAGS.forEach(({ rel, href, as, crossOrigin, fetchPriority }) => {
    if (document.querySelector(`link[rel="${rel}"][href="${href}"]`)) return

    const link = document.createElement('link')
    link.rel = rel
    link.href = href
    if (as) link.as = as
    if (crossOrigin) link.crossOrigin = crossOrigin
    if (fetchPriority) link.setAttribute('fetchpriority', fetchPriority)
    document.head.appendChild(link)
  })
}
